import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation } from "@tanstack/react-query"

export const useUploadMedia = () => {
  const { mediaApi } = useServicesContext()

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (file: File) => {
      const uploadInformation = await mediaApi.getUploadInformation(file.type)
      await mediaApi.uploadFile(file, uploadInformation)

      return { awsS3Key: uploadInformation.data.fields.key }
    },
    onSuccess: () => {},
  })

  return {
    uploadMedia: mutateAsync,
    isPending,
  }
}
